// if (document.getElementById("reviews_widget").textContent != null) {
//   alert("null");
// } else {
//   alert("not null");
// }
// var element = document.getElementsByClassName("ruk_rating_snippet");
// element[0].addEventListener("click", myFunction);
// var myFunction = function () {
//   alert("hello");
//   console.log("Hello");
// };
// document.getElementById("reviews_widget").textContent = "test";
document.getElementById("reviews_widget_frame").onload = function () {
  myFunction();
};

function myFunction() {
  alert("ifram eload");
  document.getElementById("reviews_widget_frame").innerHTML =
    "Iframe is loaded.";
}
$("#reviews_widget_frame").load(function () {
  alert("Hello");
});
